import { Stack } from '@chakra-ui/react';
import React from 'react';

import { PartTables } from './PrivacyComponents/ASection/PartTables';
import Definitions from './PrivacyComponents/ASection/Definitions';
import Foreword from './PrivacyComponents/ASection/Foreword';
import NameAndAddress from './PrivacyComponents/ASection/NameAndAddress';
import ContactDetailsDataProtection from './PrivacyComponents/ASection/ContactDetailsDataProtection';
import LegalBasisDataProcessing from './PrivacyComponents/ASection/LegalBasisDataProcessing';
import DataDeletionStorage from './PrivacyComponents/ASection/DataDeletionStorage';
import DataSecurity from './PrivacyComponents/ASection/DataSecurity';
import CooperationWithProcessors from './PrivacyComponents/ASection/CooperationWithProcessors';
import ConditionsTransferPersonalData from './PrivacyComponents/ASection/ConditionsTransferPersonalData';
import NoAutomatedDecisionMaking from './PrivacyComponents/ASection/NoAutomatedDecisionMaking';
import NoObligationProvidePersonalData from './PrivacyComponents/ASection/NoObligationProvidePersonalData';
import LegalObligationTransmitCertainData from './PrivacyComponents/ASection/LegalObligationTransmitCertainData';
import ExplanationFunction from './PrivacyComponents/BSection/ExplanationFunction';
import PersonalDataProcessed from './PrivacyComponents/BSection/PersonalDataProcessed';
import TransferPersonalDataBasisJustification from './PrivacyComponents/BSection/TransferPersonalDataBasisJustification';
import PurposeAndLegalBasisDataProcessing from './PrivacyComponents/BSection/PurposeAndLegalBasisDataProcessing';
import UseCookiesPluginsServices from './PrivacyComponents/BSection/UseCookiesPluginsServices';
import YourRights from './PrivacyComponents/BSection/YourRights';
import ChangesDataProtectionNotice from './PrivacyComponents/BSection/ChangesDataProtectionNotice';
import Contact from './PrivacyComponents/BSection/Contact';
import Severability from './PrivacyComponents/BSection/Severability';
import { colors } from '@/styles/theme/colors';
import { H3, H5, H6 } from '@/components/Headings';
import { TextSmall } from '@/components/Texts';

const PrivacyNotice = () => {
  return (
    <Stack w='full' maxW={'8xl'}>
      <Stack
        w='full'
        textAlign={'start'}
        spacing={2}
        py={{ base: 4, md: 12 }}
        maxW={'100%'}
      >
        <Stack spacing={4} textAlign={'left'} w='full'>
          <H3>Privacy notice</H3>
          <H6 size={'sm'}>Foreword</H6>
          <Foreword />
        </Stack>
        <PartTables />
        <Stack maxW={'6xl'} spacing={4} textAlign={'left'} w='full'>
          <H5 fontWeight={700}>
            <H5 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
              A.
            </H5>{' '}
            General
          </H5>
          <Definitions />
          <NameAndAddress />
          <ContactDetailsDataProtection />
          <LegalBasisDataProcessing />
          <DataDeletionStorage />
          <DataSecurity />
          <CooperationWithProcessors />
          <ConditionsTransferPersonalData />
          <NoAutomatedDecisionMaking />
          <NoObligationProvidePersonalData />
          <LegalObligationTransmitCertainData />
        </Stack>
        <Stack maxW={'6xl'} spacing={4} textAlign={'left'} w='full'>
          <H5 mt={8} fontWeight={700}>
            <H5 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
              B.
            </H5>{' '}
            Visiting websites
          </H5>
          <ExplanationFunction />
          <PersonalDataProcessed />
          <PurposeAndLegalBasisDataProcessing />
          <TransferPersonalDataBasisJustification />
          <UseCookiesPluginsServices />
          <YourRights />
          <ChangesDataProtectionNotice />
          <Severability />
          <Contact />
        </Stack>
        <Stack maxW={'6xl'} spacing={4} textAlign={'left'} w='full'>
          <TextSmall mt={4} textAlign={'end'} fontWeight={700}>
            7.12.2023
          </TextSmall>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default PrivacyNotice;
